import React from "react";

const House = () => {
  return (
    <svg
      style={{ width: "30px" }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 29.77 30.12"
    >
      <style></style>
      <g>
        <path
          style={{ fill: "#ffdf00" }}
          d="M27.13,15.36A12.15,12.15,0,1,1,15.07,3.11,12.15,12.15,0,0,1,27.13,15.36ZM18.76,22h.7c1.52,0,1.59-.08,1.59-1.59,0-1.17,0-2.34,0-3.51,0-.69,0-1.26,1-1.22.25,0,.68-.24.71-.43a1.07,1.07,0,0,0-.31-.88c-2.25-1.88-4.51-3.74-6.82-5.54a1.28,1.28,0,0,0-1.2,0c-2.31,1.8-4.58,3.65-6.83,5.52a1.17,1.17,0,0,0-.36.88.89.89,0,0,0,.69.45c.9,0,1,.47,1,1.2,0,1.32,0,2.65,0,4,0,.77.3,1.17,1.11,1.15s1.64,0,2.46,0a.87.87,0,0,0,1-1c0-.74,0-1.49,0-2.23,0-1.55,0-1.52,1.56-1.6,1.1-.05,1.63.3,1.48,1.46a7.35,7.35,0,0,0,0,1C16.5,22,16.5,22,18.76,22Z"
        />
        <path
          style={{ fill: "#002379" }}
          d="M18.76,22h.7c1.52,0,1.59-.08,1.59-1.59,0-1.17,0-2.34,0-3.51,0-.69,0-1.26,1-1.22.25,0,.68-.24.71-.43a1.07,1.07,0,0,0-.31-.88c-2.25-1.88-4.51-3.74-6.82-5.54a1.28,1.28,0,0,0-1.2,0c-2.31,1.8-4.58,3.65-6.83,5.52a1.17,1.17,0,0,0-.36.88.89.89,0,0,0,.69.45c.9,0,1,.47,1,1.2,0,1.32,0,2.65,0,4,0,.77.3,1.17,1.11,1.15s1.64,0,2.46,0a.87.87,0,0,0,1-1c0-.74,0-1.49,0-2.23,0-1.55,0-1.52,1.56-1.6,1.1-.05,1.63.3,1.48,1.46a7.35,7.35,0,0,0,0,1C16.5,22,16.5,22,18.76,22Z"
        />
      </g>
    </svg>
  );
};

export default House;
